import { OmsFlagKey } from "@redotech/feature-flags-keys-oms/keys";
import type { FeatureFlagKey } from "@redotech/feature-flags-model/keys";

export function isNewShipmentDetailsEnabled({
  featureFlags,
}: {
  featureFlags?: Partial<Record<FeatureFlagKey, boolean>> | null;
}): boolean {
  return featureFlags?.[OmsFlagKey.NEW_SHIPMENT_DETAILS] === true;
}
